import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MyFavorites = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const isArabic = i18n.language === "ar";

  const [favorites, setFavorites] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedRating, setSelectedRating] = useState("all");

  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetchFavorites();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000 });
    fetchFavorites();
    fetchSpecialities();
  }, []);

  // جلب التخصصات من الـ API
  const fetchSpecialities = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/lookups/specialities");
      console.log("البيانات القادمة:", response.data);

      const items = response.data.items;

      if (Array.isArray(items)) {
        console.log("تم تحميل التخصصات:", items);
        setCategories(items);
      } else {
        console.warn("الـ items غير موجودة أو ليست مصفوفة!");
      }
    } catch (error) {
      console.error("فشل تحميل التخصصات:", error);
    }
  };

  useEffect(() => {
    fetchSpecialities();
  }, []);

  const fetchFavorites = async () => {
    try {
      const response = await axiosInstance.get("/api/v1/favorites");
      setFavorites(response.data.items);
    } catch (error) {
      console.error("Error fetching favorites", error);
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const handleRatingChange = (rating) => {
    setSelectedRating(rating);
  };

  const addToFavorites = async (speakerId) => {
    try {
      await axiosInstance.post(`/api/v1/favorites/speakers/${speakerId}`);
      fetchFavorites(); // Re-fetch the favorites after adding
    } catch (error) {
      console.error("Error adding to favorites", error);
    }
  };

  const removeFromFavorites = async (speakerId) => {
    try {
      await axiosInstance.delete(`/api/v1/favorites/speakers/${speakerId}`);
      fetchFavorites();
      toast.success(t("favoriteRemoved"));
    } catch (error) {
      console.error("Error removing from favorites", error);
      toast.error(t("errorUpdatingFavorite"));
    }
  };

  const filteredFavorites = favorites.filter((favorite) => {
    const search = searchQuery.toLowerCase();

    // تصفية البحث حسب الاسم بالعربية أو الإنجليزية
    const matchesSearch =
      favorite.arabicFullName?.toLowerCase().includes(search) ||
      favorite.englishFullName?.toLowerCase().includes(search) ||
      favorite.arabicJobTitle?.toLowerCase().includes(search) ||
      favorite.englishJobTitle?.toLowerCase().includes(search) ||
      favorite.arabicOrganizationName?.toLowerCase().includes(search) ||
      favorite.englishOrganizationName?.toLowerCase().includes(search);

    // تصفية حسب التخصص
    const matchesCategory =
      selectedCategory === "all" ||
      favorite.specialities?.some(
        (spec) =>
          spec.name === selectedCategory ||
          spec.arabicName === selectedCategory ||
          spec.englishName === selectedCategory
      );

    // تصفية حسب التقييم
    const matchesRating =
      selectedRating === "all" || favorite.rating >= selectedRating;

    return matchesSearch && matchesCategory && matchesRating;
  });

  const handleCategoryClick = (category) => {
    handleCategoryChange(category);
  };

  const handleRatingClick = (rating) => {
    handleRatingChange(rating);
  };

  return (
    <div dir={languageDirection}>
      <style>
        {`
.favorite-card {
      transition: all 0.3s ease;
      border-radius: 12px;
      overflow: hidden;
    }
    
    .favorite-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0,0,0,0.1);
    }
    
    .favorite-card .card-img-top {
      height: 200px;
      object-fit: cover;
    }
    
    .favorite-badge {
      position: absolute;
      top: 10px;
      right: 10px;
      background: rgba(255, 255, 255, 0.9);
      color: var(--primary-color);
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      cursor: pointer;
      box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    }
    
    .favorite-badge:hover {
      transform: scale(1.1);
    }
    
    .rating-stars {
      color: #ffc107;
    }
    
    .empty-state {
      padding: 60px 20px;
    }
    
    .filter-dropdown {
      min-width: 200px;
    }
    
    .category-badge {
      background-color: var(--light-primary-color);
      color: var(--primary-color);
      font-size: 0.75rem;
      padding: 0.25rem 0.5rem;
      border-radius: 4px;
      margin-right: 0.25rem;
      margin-bottom: 0.25rem;
      display: inline-block;
`}
      </style>
      <section className="bg-light py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <h1
                className="text-center mb-4 fw-bold text-primary-custom"
                data-translate="my_favorites"
              >
                {t("my_favorites")}
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/" data-translate="home">
                      {t("home")}
                    </a>
                  </li>
                  {/* <li className="breadcrumb-item">
                    <a href="/profile" data-translate="my_profile">
                      {t("my_profile")}
                    </a>
                  </li> */}
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    data-translate="my_favorites"
                  >
                    {t("my_favorites")}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card shadow-sm mb-4">
                <div className="card-body p-3">
                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div className="d-flex align-items-center">
                      {/* <h5 className="mb-0 me-3" data-translate="filter_by">
                        {t("filter_by")}
                      </h5> */}
                      {/* <div className="dropdown">
                        <button
                          className="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="categoryDropdown"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          data-translate="category"
                        >
                          {t("category")}
                        </button>
                        <ul
                          className="dropdown-menu filter-dropdown"
                          aria-labelledby="categoryDropdown"
                        >
                          <li>
                            <a
                              className="dropdown-item"
                              href="#"
                              onClick={() => handleCategoryClick("all")}
                            >
                              {t("all_categories")}
                            </a>
                          </li>

                          {categories.length > 0 ? (
                            categories.map((category) => (
                              <li
                                key={category.id}
                                className="dropdown-submenu position-relative"
                              >
                                <a
                                  className="dropdown-item dropdown-toggle"
                                  href="#"
                                  onClick={(e) => e.preventDefault()}
                                >
                                  {isArabic
                                    ? category.arabicName
                                    : category.englishName}
                                </a>

                                {category.subcategories?.length > 0 && (
                                  <ul className="dropdown-menu start-100 top-0">
                                    {category.subcategories.map((sub) => (
                                      <li key={sub.id}>
                                        <a
                                          className="dropdown-item"
                                          href="#"
                                          onClick={() =>
                                            handleCategoryClick(
                                              isArabic
                                                ? sub.arabicName
                                                : sub.englishName
                                            )
                                          }
                                        >
                                          {isArabic
                                            ? sub.arabicName
                                            : sub.englishName}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </li>
                            ))
                          ) : (
                            <li>
                              <a className="dropdown-item" href="#">
                                {t("loading_categories")}
                              </a>
                            </li>
                          )}
                        </ul>
                      </div> */}
                    </div>

                    <div className="input-group" style={{ maxWidth: "300px" }}>
                      <input
                        type="text"
                        className="form-control"
                        id="favoriteSearch"
                        placeholder={t("search_favorites")}
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        id="searchButton"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row g-4" id="favoritesList">
                {filteredFavorites.length > 0 ? (
                  filteredFavorites.map((favorite) => (
                    <div
                      key={favorite.id}
                      className="col-xl-3 col-lg-4 col-md-6"
                    >
                      <a
                        href={`/speaker-detail/${favorite.id}`}
                        className="speaker-card-link"
                      >
                        <div className="card speaker-card shadow-sm h-100">
                          <button
                            className="favorite-btn favorite-btn-active"
                            aria-label="إزالة من المفضلة"
                            data-speaker-id={favorite.id}
                            onClick={(e) => {
                              e.preventDefault();
                              removeFromFavorites(favorite.id);
                            }}
                          >
                            <i className="fas fa-star"></i>
                          </button>

                          <div className="speaker-img-container">
                            <img
                              src={
                                favorite.profileImage ||
                                "/website/assets-v2/default-avatar.png"
                              }
                              className="speaker-img"
                              alt={favorite.arabicFullName}
                            />
                            <div className="speaker-bio-overlay">
                              <div className="speaker-bio-content">
                                <p>
                                  {favorite.arabicShortBiography ||
                                    "لا توجد نبذة مختصرة"}
                                </p>
                              </div>
                            </div>
                          </div>

                          <div className="card-body">
                            <h5 className="card-title fw-bold">
                              {favorite.arabicFullName}
                            </h5>
                            <p className="card-text text-muted">
                              {favorite.arabicJobTitle ||
                                "المسمى الوظيفي غير متوفر"}
                            </p>
                            <div className="speaker-location">
                              <i className="fas fa-map-marker-alt me-1"></i>
                              <span>
                                {favorite?.speakerSpecialies?.city
                                  ? isArabic
                                    ? favorite.speakerSpecialies.city.arabicName
                                    : favorite.speakerSpecialies.city
                                        .englishName
                                  : "—"}
                                {favorite?.speakerSpecialies?.city?.state && (
                                  <>
                                    ,{" "}
                                    {isArabic
                                      ? favorite.speakerSpecialies.city.state
                                          .arabicName
                                      : favorite.speakerSpecialies.city.state
                                          .englishName}
                                  </>
                                )}
                              </span>
                            </div>

                            <div className="mt-2">
                              {favorite.speakerSpecialies?.length > 0 ? (
                                favorite.speakerSpecialies.map(
                                  (spec, index) => (
                                    <span
                                      key={index}
                                      className="topic-badge"
                                      data-category={spec}
                                    >
                                      {spec}
                                    </span>
                                  )
                                )
                              ) : (
                                <span className="topic-badge">بدون تصنيف</span>
                              )}
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  ))
                ) : (
                  <div id="emptyState" className="card shadow-sm mb-5">
                    <div className="card-body p-4">
                      <div className="text-center empty-state">
                        <img
                          src="/website/assets-v2/no-favorites.svg"
                          alt="No Favorites"
                          className="mb-4"
                          style={{ maxWidth: "200px" }}
                        />
                        <h3 className="mb-3">{t("no_favorites")}</h3>
                        <p className="text-muted mb-4">
                          {t("add_favorites_prompt")}
                        </p>
                        <a
                          href="/speakers"
                          className="btn btn-sm btn-outline-primary rounded-pill px-3"
                        >
                          {t("browse_speakers")}
                        </a>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default MyFavorites;
